import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import likeService from '../../services/likeService';
import authService from '../../services/authService';

export default function PostStyle4({
  thumbnailSrc,
  category,
  categoryId,
  title,
  subTitle,
  id,
  likeCount = 0,
  isLiked = false,
  likeId = null,
  onLikeChange,
}) {
  const navigate = useNavigate();
  const [localLikeCount, setLocalLikeCount] = useState(likeCount);
  const [localIsLiked, setLocalIsLiked] = useState(isLiked);
  const [localLikeId, setLocalLikeId] = useState(likeId);
  const [isLoading, setIsLoading] = useState(false);

  const handleLikeClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Check if user is authenticated
    if (!authService.isAuthenticated()) {
      navigate('/login');
      return;
    }

    // Prevent multiple clicks
    if (isLoading) return;

    setIsLoading(true);

    try {
      const user = authService.getUser();
      if (!user) {
        navigate('/login');
        return;
      }

      if (localIsLiked) {
        // Unlike the post
        await likeService.unlikePost(localLikeId);
        setLocalIsLiked(false);
        setLocalLikeId(null);
        setLocalLikeCount(prev => Math.max(0, prev - 1));

        if (onLikeChange) {
          onLikeChange(id, false, null, localLikeCount - 1);
        }
      } else {
        // Like the post
        const result = await likeService.likePost(id, user.id);
        setLocalIsLiked(true);
        setLocalLikeId(result.likeId);
        setLocalLikeCount(prev => prev + 1);

        if (onLikeChange) {
          onLikeChange(id, true, result.likeId, localLikeCount + 1);
        }
      }
    } catch (error) {
      console.error('Error toggling like:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const formatLikeCount = (count) => {
    if (count === 0) return '';
    if (count < 1000) return count.toString();
    if (count < 1000000) return (count / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    return (count / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  };

  return (
    <div className="cs_post cs_style_4">
      <div className="cs_post_thumb_wrap position-relative">
        <Link to={`${id}`} className="cs_post_thumb cs_radius_15">
          <img src={thumbnailSrc} alt="Thumb" />
        </Link>
        <div className="cs_categories">
          <Link to={categoryId ? `/blog?category=${categoryId}` : `/blog`} className="cs_category">
            {category}
          </Link>
        </div>
        <button
          className={`cs_like_btn ${localIsLiked ? 'liked' : ''}`}
          onClick={handleLikeClick}
          disabled={isLoading}
          title={localIsLiked ? 'Unlike this post' : 'Like this post'}
        >
          {localIsLiked ? <FaHeart /> : <FaRegHeart />}
          {localLikeCount > 0 && <span>{formatLikeCount(localLikeCount)}</span>}
        </button>
      </div>
      <h2 className="cs_post_title cs_fs_50">
        <Link to={`${id}`}>{title}</Link>
      </h2>
      <p className="cs_post_subtitle">{subTitle}</p>
      <Link to={`${id}`} className="cs_post_btn">
        <span>Read More</span>
        <svg
          width={51}
          height={16}
          viewBox="0 0 51 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M50.7071 8.70711C51.0976 8.31658 51.0976 7.68342 50.7071 7.29289L44.3431 0.928932C43.9526 0.538408 43.3195 0.538408 42.9289 0.928932C42.5384 1.31946 42.5384 1.95262 42.9289 2.34315L48.5858 8L42.9289 13.6569C42.5384 14.0474 42.5384 14.6805 42.9289 15.0711C43.3195 15.4616 43.9526 15.4616 44.3431 15.0711L50.7071 8.70711ZM0 9H50V7H0V9Z"
            fill="currentColor"
          />
        </svg>
      </Link>
    </div>
  );
}
